import { createFileRoute } from '@tanstack/react-router'
import { vtoLook } from '@/lib/queries/vto-looks'
import { VTOPage } from '@/features/workspaces/vto'
import { vtoSearchSchema } from '@/features/workspaces/vto/vto-search-schema'

function VTORouteComponent() {
  const { orgId, workspaceId } = Route.useParams()
  return <VTOPage orgId={orgId} workspaceId={workspaceId} />
}

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/vto/'
)({
  validateSearch: vtoSearchSchema,
  // Only preload the filter options used by the grid's filter dropdowns.
  // The looks list is fetched by the grid itself — its query key includes the
  // grid's filter object, which is constructed at render time and can't be
  // matched by a route loader without duplicating the filter-building logic.
  loader: async ({ context, params }) => {
    await context.queryClient.query({
      ...vtoLook.findFilterOptions(params.workspaceId),
      staleTime: 'static',
    })
  },
  staticData: { layout: 'fluid' },
  component: VTORouteComponent,
})
